/* eslint-disable @typescript-eslint/camelcase */
// eslint-disable-next-line max-classes-per-file
export class AttendanceMap {
  booked: number[] = [];

  checked_in: number[] = [];
}

export default class Session {
  id = '';

  event_id = 0;

  starts_at = '';

  ends_at = '';

  client_ids: number[] = [];

  staff_ids: number[] = [];

  resource_ids: number[] = [];

  registration_ids: string[] = [];

  schedule_id = 0;

  status = '';

  created_at = '';

  updated_at = '';

  attendance_map: AttendanceMap = {
    booked: [],
    checked_in: [],
  } as AttendanceMap;
}
